import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { CwActionIcon } from '@bbraun/cortex-angular';

@Component({
  selector: 'app-action-button',
  imports: [CwActionIcon],
  templateUrl: './action-button.component.html',
  styleUrl: './action-button.component.sass',
  encapsulation: ViewEncapsulation.ShadowDom
})
export class ActionButtonComponent {
  @Input() hasDelete: boolean;
  @Output() detailClick: EventEmitter<void> = new EventEmitter();
  @Output() deleteClick: EventEmitter<void> = new EventEmitter();

  onDetail(event: MouseEvent) {
    event.stopPropagation();
    this.detailClick.emit();
  }

  onDelete(event: MouseEvent) {
    event.stopPropagation();
    this.deleteClick.emit();
  }
}
